import { createContext, useContext } from 'react';

export type ToastTone = 'success' | 'error' | 'info';
export interface ToastInput {
  title: string;
  description?: string;
  tone?: ToastTone;
}

export const ToastContext = createContext<{ toast: (t: ToastInput) => void }>({ toast: () => {} });

export function useToast() {
  return useContext(ToastContext).toast;
}
